import { mapMediaData } from '~admin/model/media-data.mapper';
import { SponsorData } from '~admin/model/sponsor-data';
import { SponsorResponse } from '~client/model/sponsor-response';

export const mapSponsorData = (response: SponsorResponse): SponsorData => {
  const { icon, id, url } = response;

  return {
    icon: mapMediaData(icon),
    id: Number(id),
    url,
  };
};

export const mapSponsorDataList = (response: SponsorResponse[]): SponsorData[] =>
  response.map(mapSponsorData);



// WEBPACK FOOTER //
// ./model/sponsor-data.mapper.ts